import { useState } from 'react'

import Button from 'common/components/button'
import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import EmptyState from 'common/components/emptyState'
import PageHeader from 'common/components/PageHeader'
import PageTitle from 'common/components/PageTitle'
import { useAppSelector } from 'common/hooks/redux'

import useGetCustomerAttributeRecordsQuery from '../api/queries/useGetCustomerAttributeRecordsQuery'

import CreateRecordModal from './createRecord/CreateRecordModal'
import CustomerAttributesTable from './CustomerAttributesTable'

const statesForQA = ['noRecords', 'noData', 'data'] as const

const CustomerAttributes = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false)
  const [selectedRecord, setSelectedRecord] =
    useState<string | undefined>(undefined)
  const customerAttributeRecordsQuery = useGetCustomerAttributeRecordsQuery({
    accountId,
  })

  const [stateToQA, setStateToQA] = useState<'noRecords' | 'noData' | 'data'>(
    statesForQA[0]
  )
  return (
    <div className="flex flex-1 flex-col gap-12">
      <PageHeader>
        <div className="flex justify-between flex-1">
          <div className="pt-9">
            <PageTitle title="Customer attributes" />
            <div className="text-coolGray-400">
              Configure the below settings to let Jacquard know what we should
              or should not use in the generation of your content.
            </div>
          </div>
        </div>
      </PageHeader>
      {stateToQA === 'noRecords' && (
        <EmptyState
          title="Start creating your first record"
          description="We don’t have any records stored. "
          action={
            <Button
              variant="primary"
              onClick={() => {
                setIsCreateModalVisible(true)
              }}
            >
              Create record
            </Button>
          }
        />
      )}
      {stateToQA !== 'noRecords' && (
        <CustomerAttributesTable
          baseUrl=""
          onChangeRecord={setSelectedRecord}
          selectedRecord={
            selectedRecord ?? customerAttributeRecordsQuery.data?.[0]?.id
          }
          records={customerAttributeRecordsQuery.data ?? []}
          attributes={
            stateToQA === 'data'
              ? [
                  {
                    id: '1',
                    name: 'attribute1',
                    description: `Gold Tier
Premium tier for high-value customers, featuring significant discounts, priority customer service, exclusive events, and unlimited free shipping, aimed at rewarding and retaining top customers.

Silver Tier
Mid-level tier for moderate spenders, providing better discounts, early access to sales, and free shipping on larger orders to foster loyalty.
 
Bronze Tier
Entry-level for new or infrequent customers, offering basic rewards like small discounts and exclusive promotions to encourage repeat purchases.`,
                  },
                ]
              : []
          }
          onAddNewRecord={() => setIsCreateModalVisible(true)}
        />
      )}
      <div className="w-min">
        <ButtonWithTooltip
          tooltip
          tooltipText="Button used for QA only to navigate during different states until BE is ready"
          onClick={() =>
            setStateToQA((prevState) => {
              const currentIndex = statesForQA.indexOf(prevState)
              const nextIndex = (currentIndex + 1) % statesForQA.length
              return statesForQA[nextIndex]
            })
          }
          variant="primary"
        >
          Next state (FOR QA only)
        </ButtonWithTooltip>
      </div>

      <CreateRecordModal
        isVisible={isCreateModalVisible}
        onClose={() => {
          setIsCreateModalVisible(false)
        }}
      />
    </div>
  )
}

export default CustomerAttributes
